import { render, staticRenderFns } from "./products.vue?vue&type=template&id=8ea43178&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=8ea43178&prod&scoped=true&lang=css"
import style1 from "./products.vue?vue&type=style&index=1&id=8ea43178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea43178",
  null
  
)

export default component.exports